import { FunctionComponent } from 'preact';
import './MastheadGrid.css';
import { MastheadImage } from '../MastheadImage';
import { MastheadSkeleton } from '../MastheadSkeleton';

// Using the Book type as defined in useFeaturedBooks
interface Book {
  id: number;
  title: string;
  permalink: string;
  description: string;
  coverImageThumb: string | null;
  coverImageMed: string | null;
  coverImageFull: string | null;
  tags: string[] | null;
  meanRating: number | null;
  totalReviews: number | null;
  wordCount: number | null;
  chapterCount: number | null;
  author: Record<string, any>;
  lastUpdated: string;
}

interface MastheadGridProps {
  books: Book[];
  loading: boolean;
  error: string | null;
  cdnUrl: string;
  baseBookCoverImageUrl: string;
  limit: number;
}

export const MastheadGrid: FunctionComponent<MastheadGridProps> = ({
  books,
  loading,
  error,
  cdnUrl,
  baseBookCoverImageUrl,
  limit,
}) => {
  return (
    <div className="masthead-grid">
      {loading &&
        Array.from({ length: limit }).map((_, i) => (
          <MastheadSkeleton key={i} />
        ))}
      {error && <div className="masthead-error">{error}</div>}

      {!loading &&
        !error &&
        books.map((book) => (
          <MastheadImage
            key={book.id}
            book={book}
            cdnUrl={cdnUrl}
            baseBookCoverImageUrl={baseBookCoverImageUrl}
          />
        ))}
    </div>
  );
};
